import React from "react";
import { AddRackOptions } from "../../constants";
import { DateSelector } from "../selectors/DateSelector";
import { FillRackSelector } from "../selectors/FillRackSelector";
import { PassageNumberSelector } from "../selectors/PassageNumberSelector";
import { RunSelector } from "../selectors/RunSelector";

interface EBCollectionProps {
  values: AddRackOptions;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

export const EBCollection = ({ values, setFieldValue }: EBCollectionProps) => {
  return (
    <React.Fragment>
      <RunSelector values={values} setFieldValue={setFieldValue} />
      {values.run.includes("1T5") ? (
        <FillRackSelector values={values} setFieldValue={setFieldValue} />
      ) : null}
      <PassageNumberSelector values={values} setFieldValue={setFieldValue} />
      <DateSelector values={values} setFieldValue={setFieldValue} />
    </React.Fragment>
  );
};
